import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import PoliciesDTO from '../../../dto/PoliciesDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { createClearObject } from '../../../utils/utils';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadZoneList } from '../../Zones/actions';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { PROVIDER_LIST } from '../../../configs';
import { loadRulesList } from '../../Rules/actions';
import SelectGeographies from '../../Rules/components/SelectGeographies';
import { loadProviderList } from '../../Provider/actions';

export default function FilterForm(props) {
  const {
    onHide, getValues, reset, defaultValues, setValue, control,
  } = props;
  const { formatMessage } = useIntl();
  const DTO = new PoliciesDTO();
  const attributes = DTO.getAttributesByName();
  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };
  const save = () => {
    onHide();
  };

  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={save}
      open
    >
      <DialogTitle header={formatMessage({ id: 'filters' })} title={<Icons onClick={onHide} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content custom-scroll-theme">
        <form className="filter-content-wrapper">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.description}
            variant="material"
            withLabel
            className="mb-3"
            textarea
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.currency}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.start_date}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.end_date}
            variant="material"
            withLabel
            className="mb-3"
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.published_date}
            variant="material"
            withLabel
            className="mb-3"
          />
          {/* <FieldDTOWithCol */}
          {/*  control={control} */}
          {/*  type="text" */}
          {/*  component={CustomSelectInput} */}
          {/*  dtoObject={attributes.provider_ids} */}
          {/*  variant="material" */}
          {/*  withLabel */}
          {/*  options={PROVIDER_LIST} */}
          {/*  className="mb-3" */}
          {/* /> */}
          <FieldDTOWithCol
            control={control}
            dtoObject={attributes.provider_ids}
            usePortal
            component={SelectGeographies}
            portalClassName="executor-selector"
            loadAction={loadProviderList}
            optionFormatter={item => ({ value: item.id, name: item.name })}
            filterName="full_name"
            variant="material"
            withLabel
            className="mb-3"
            // multiple
          />
          <FieldDTOWithCol
            control={control}
            dtoObject={attributes.rules}
            usePortal
            addPlaceholder
            component={CustomSelectInputWithHelper}
            portalClassName="executor-selector"
            loadAction={loadRulesList}
            optionFormatter={item => ({ value: item.rule_id, name: item.name })}
            filterName="full_name"
            variant="material"
            withLabel
            className="mb-3"
          />
        </form>
      </DialogContent>
      <DialogFooter className="hff-footer">
        {/* <div className="hff-footer-text">{formatMessage({ id: 'find' }, { count: meta.count })}</div> */}
        <div className="hff-footer-buttons hff-center">
          {/* <Button className="hff-clear-show" onClick={save}>{formatMessage({ id: 'show' })}</Button> */}
          <Button className="hff-clear-data" variant="secondary" onClick={clear}>{formatMessage({ id: 'clear.all' })}</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
